import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carBlackWhiteList/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/carBlackWhiteList/detail',
    method: 'get',
    params: data,
  })
}
export async function searchData(data) {
  return request({
    url: '/carBlackWhiteList/get',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/carBlackWhiteList/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/carBlackWhiteList/edit',
    method: 'post',
    data,
  })
}
export async function pushData(data) {
  return request({
    url: '/carBlackWhiteList/push',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/carBlackWhiteList/delete',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/carBlackWhiteList/revoke',
    method: 'post',
    data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/v2/carBlackWhiteList/check/process/info',
    method: 'post',
    data,
  })
}